// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"7eb78981","839":"e70cc468","883":"9ddda877"}[chunkId] + ".chunk.css";
};